/* Zafari (2026-10-16): tres comportamientos del carrito lateral de Hyper. Todo por delegación en document: Hyper re-dibuja el
   contenido del drawer en cada cambio.
   1) Al enfocar la cantidad se selecciona el número entero: en el celular se escribe el valor nuevo directo.
   2) Cerrar deslizando hacia la derecha (≤ 768 px): el panel (.drawer__inner) sigue al dedo y la capa de atrás se aclara;
      al soltar se cierra si pasó el 30 % del ancho o fue un envión (> 0,5 px/ms y > 40 px); si no, vuelve. Desde el 17-10
      con touch events y prioridad al gesto de cerrar sobre el scroll (ver más abajo).
      Al cerrar, el panel termina de salir con una transición corta propia y la capa gris se apaga con una transición
      (Hyper espera el transitionend de esa capa para esconder el drawer: con "transition: none" se quedaba congelado
      medio segundo a mitad de camino, que era la queja del dueño). Los estilos en línea se limpian cuando Hyper avisa
      drawer:handleAfterHide.
   3) Al abrir, el foco va al panel y no al botón de cerrar (en iOS quedaba el aro azul).
   17-10: el menú del celular (menu-drawer, sale por la izquierda) también se cierra deslizando, hacia la izquierda (pedido
   del dueño: "no desliza"); mismo gesto con dir = -1. */
(function () {
  'use strict';

  /* 1) cantidad: seleccionar todo al enfocar */
  document.addEventListener('focusin', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('cart-drawer .quantity__input')) return;
    setTimeout(function () { try { input.select(); } catch (x) {} }, 0);
  });

  /* 2) deslizar para cerrar */
  var SWIPE_MQ = '(max-width: 768px)';
  var SLOP = 8, CLOSE_RATIO = 0.3, FLICK_SPEED = 0.5, FLICK_MIN = 40, SETTLE_MS = 250, OUT_MS = 220;
  var swipe = null;

  function stamp(evt) { return evt.timeStamp > 0 ? evt.timeStamp : (window.performance ? performance.now() : Date.now()); }
  function matches(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }

  function render() {
    if (!swipe) return;
    swipe.raf = 0;
    swipe.panel.style.transform = 'translate3d(' + swipe.dir * swipe.offset + 'px, 0, 0)';
    if (swipe.overlay) swipe.overlay.style.opacity = String(Math.max(0, 1 - swipe.offset / swipe.width));
  }

  function clearInline(panel, overlay) {
    panel.style.transform = '';
    panel.style.transition = '';
    if (overlay) { overlay.style.opacity = ''; overlay.style.transition = ''; }
  }

  function release(cancelled, t) {
    var s = swipe;
    swipe = null;
    if (!s || s.mode !== 'x') return;
    if (s.raf) cancelAnimationFrame(s.raf);
    var reduce = matches('(prefers-reduced-motion: reduce)');
    var speed = s.offset / Math.max(1, (t || s.t1) - s.t0);
    var closing = !cancelled && (s.offset > s.width * CLOSE_RATIO || (speed > FLICK_SPEED && s.offset > FLICK_MIN));
    var panel = s.panel, overlay = s.overlay, drawer = s.drawer;
    if (closing) {
      /* el panel sale del todo con una transición corta; la capa gris se apaga con transición (1 ms con reduced-motion)
         para que Hyper reciba su transitionend y esconda el drawer en seguida */
      var out = reduce ? 1 : OUT_MS;
      panel.style.transition = 'transform ' + out + 'ms cubic-bezier(.2, .7, .3, 1)';
      panel.style.transform = 'translate3d(' + s.dir * (s.width + 4) + 'px, 0, 0)';
      if (overlay) { overlay.style.transition = 'opacity ' + out + 'ms ease, visibility ' + out + 'ms'; overlay.style.opacity = '0'; }
      var done = false;
      var finish = function () { if (done) return; done = true; drawer.removeEventListener('drawer:handleAfterHide', finish); clearInline(panel, overlay); };
      drawer.addEventListener('drawer:handleAfterHide', finish);
      setTimeout(finish, 1500);
      if (typeof drawer.hide === 'function') drawer.hide(); else { var btn = drawer.querySelector('.drawer__close-btn') || document.querySelector('.menu-drawer-button[aria-expanded="true"]'); if (btn) btn.click(); }
      return;
    }
    panel.style.transition = reduce ? 'none' : 'transform ' + SETTLE_MS + 'ms ease';
    panel.style.transform = '';
    if (overlay) { overlay.style.transition = reduce ? 'none' : 'opacity ' + SETTLE_MS + 'ms ease'; overlay.style.opacity = ''; }
    setTimeout(function () { clearInline(panel, overlay); }, SETTLE_MS + 20);
  }

  /* 17-10: el gesto va con touch events y un touchmove NO pasivo en cada drawer (no en document, así el scroll del resto de
     la página no espera a este script). Apenas el dedo se mueve SLOP px se decide la dirección con prioridad al lado de
     cerrar: alcanza con que el movimiento horizontal sea el 60 % del vertical (hasta ~59° de inclinación). Desde ahí cada
     touchmove se cancela, así el panel no scrollea a la vez ni se mezcla (pedido del dueño: "el deslizamiento a la derecha
     debe ser prioritario"). Si gana el vertical, el gesto queda entero para el scroll. Antes eran Pointer Events pasivos con
     touch-action: pan-y, y en el iPhone un gesto en diagonal movía el panel y scrolleaba al mismo tiempo. */
  var H_BIAS = 0.6;

  function touchById(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].identifier === id) return list[i];
    return null;
  }

  function onTouchStart(evt) {
    if (swipe) release(true);
    if (evt.touches.length !== 1 || !matches(SWIPE_MQ)) return;
    var drawer = evt.currentTarget;
    if (!drawer.hasAttribute('open')) return;
    var panel = drawer.querySelector('.drawer__inner');
    if (!panel || !panel.contains(evt.target)) return;
    var t = evt.touches[0];
    swipe = { dir: drawer.tagName === 'MENU-DRAWER' ? -1 : 1, id: t.identifier, drawer: drawer, panel: panel, overlay: drawer.querySelector('.fixed-overlay'), x0: t.clientX, y0: t.clientY, t0: stamp(evt), t1: stamp(evt), offset: 0, width: panel.offsetWidth || window.innerWidth, mode: null, raf: 0 };
  }

  function onTouchMove(evt) {
    if (!swipe || swipe.drawer !== evt.currentTarget) return;
    var t = touchById(evt.touches, swipe.id);
    if (!t) return;
    var dx = t.clientX - swipe.x0, dy = t.clientY - swipe.y0;
    if (swipe.mode === null) {
      if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
      if (swipe.dir * dx > 0 && Math.abs(dx) >= Math.abs(dy) * H_BIAS) {
        swipe.mode = 'x';
        swipe.panel.style.transition = 'none';
        if (swipe.overlay) swipe.overlay.style.transition = 'none';
      } else {
        swipe.mode = 'y';
        return;
      }
    }
    if (swipe.mode !== 'x') return;
    if (evt.cancelable) evt.preventDefault();
    swipe.offset = Math.max(0, swipe.dir * dx);
    swipe.t1 = stamp(evt);
    if (!swipe.raf) swipe.raf = requestAnimationFrame(render);
  }

  function onTouchEnd(evt) {
    if (!swipe || swipe.drawer !== evt.currentTarget || touchById(evt.touches, swipe.id)) return;
    if (swipe.mode === 'x') release(false, stamp(evt));
    else swipe = null;
  }

  function onTouchCancel(evt) {
    if (swipe && swipe.drawer === evt.currentTarget) release(true);
  }

  function bind(drawer) {
    if (drawer.__zfSwipe) return;
    drawer.__zfSwipe = true;
    drawer.addEventListener('touchstart', onTouchStart, { passive: true });
    drawer.addEventListener('touchmove', onTouchMove, { passive: false });
    drawer.addEventListener('touchend', onTouchEnd, { passive: true });
    drawer.addEventListener('touchcancel', onTouchCancel, { passive: true });
  }
  function scanSwipe() { document.querySelectorAll('cart-drawer, menu-drawer').forEach(bind); }
  scanSwipe();
  document.addEventListener('DOMContentLoaded', scanSwipe);
  new MutationObserver(scanSwipe).observe(document.body, { childList: true });
})();

/* 3) al abrir, el foco va al panel y no al botón de cerrar (Hyper enfoca el primer control y en iOS queda el aro azul) */
(function () {
  'use strict';
  function focusPanel(drawer) {
    var panel = drawer.querySelector('.drawer__inner');
    if (!panel) return;
    if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (x) {} }, 30);
  }
  function watch(drawer) {
    if (drawer.__zfWatched) return;
    drawer.__zfWatched = true;
    // Hyper enfoca el botón de cerrar al terminar la animación de apertura (drawer:handleAfterShow): después de eso, al panel
    drawer.addEventListener('drawer:handleAfterShow', function () { focusPanel(drawer); });
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].attributeName === 'open' && drawer.hasAttribute('open')) { focusPanel(drawer); setTimeout(function () { focusPanel(drawer); }, 600); }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
  // 17-10: también el menú del celular (al abrirse el tema enfocaba "Todos" y Safari dibujaba un recuadro azul)
  function scan() { document.querySelectorAll('cart-drawer, menu-drawer').forEach(watch); }
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.body, { childList: true });
})();
